import React from 'react'

import Link from 'components/Link'
import { Posts } from 'components/Blog'
import { prepareData } from 'utils/googleData'

type TutorialsProps = {
    tutorials: {
        edges: {
            node: any
        }[]
    }
}

export function Tutorials(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, tutorials, gatsbyImageSrc } =
        prepareData({
            props,
        })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const tutorialsPosts = props?.tutorials?.edges || tutorials
    const sectionTitle = title || 'Tutorials'
    const ctaLabel = cta?.label || 'View all'
    const ctaUrl = cta?.url || '/tutorials/all'
    return (
        <section className="my-12">
            <div className="mb-6 flex items-center justify-between">
                <h3 className="m-0">{sectionTitle}</h3>
                <Link to="/docs/tutorials">{ctaLabel}</Link>
            </div>
            {tutorialsPosts && <Posts posts={tutorialsPosts} action={<Link to={ctaUrl}>{ctaLabel}</Link>} />}
        </section>
    )
}
export default Tutorials
